import { getCurrentProfileSelect } from '../get-current'
import { createSelector } from 'reselect'
import { getValueReduxUtil } from '../../../../redux/utils'
import { FITNESS_DATA_REQUIRED_PROFILE_KEYS } from '../../../../../models/profile/constants'

const hasCompletedFitnessDataProfileSelect = createSelector(getCurrentProfileSelect,
  (profile) => {
    const trainingData = FITNESS_DATA_REQUIRED_PROFILE_KEYS.filter(trainingKey => getValueReduxUtil(
      profile,
      trainingKey
    ) != null)
    return trainingData.length === FITNESS_DATA_REQUIRED_PROFILE_KEYS.length
  }
)

export default hasCompletedFitnessDataProfileSelect
